import React, { createContext, JSX, ReactNode, useCallback, useState } from 'react';

export type LastVisitedCtx = {
  lastVisitedTimestamp: number;
  updateTimestamp: (ts: number) => void;
};

const LogTimestampContext = createContext<LastVisitedCtx>({
  lastVisitedTimestamp: 0,
  updateTimestamp: () => {},
});

export const LogTimestampProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [lastVisitedTimestamp, setLastVisitedTimestamp] = useState<number>(0);

  const updateTimestamp = useCallback((ts: number) => {
    setLastVisitedTimestamp(ts);
  }, []);

  return (
    <LogTimestampContext.Provider value={{ lastVisitedTimestamp, updateTimestamp }}>
      {children}
    </LogTimestampContext.Provider>
  );
};

export const useLogTimestamp = (): LastVisitedCtx => React.useContext(LogTimestampContext);
